import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {NumericOperatorType} from "../../../../../../models/numeric-operator";

@Component({
  selector: "money-determinant",
  templateUrl: "./money-determinant.component.html",
  styles: [],
})
export class MoneyDeterminantComponent implements OnInit, OnChanges {

  public operators: string[];
  @Input() public operator: NumericOperatorType;
  @Input() public moneyValue: number;
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;

  @Output() public moneyValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();

  public ngOnInit() {
    this.operators = Object.keys(NumericOperatorType);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.operator && changes.operator.currentValue) {
      this.operator = changes.operator.currentValue;
    }
    if (changes.moneyValue && changes.moneyValue.currentValue) {
      this.moneyValue = changes.moneyValue.currentValue;
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "number"));
    }
  }

  public moneyValueChanged(newValue: number) {
    this.moneyValueResponse.emit({moneyValue: newValue});
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.moneyValueResponse.emit({sourceFormFieldKey: this.sourceFormFieldKey});
  }
}
